import React, { useState } from "react";
import { ChevronDownIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import combineClassName from "./utils/combineClassName";

interface AccordionProps {
  title: React.ReactNode;
  children: React.ReactNode;
  defaultOpen?: boolean;
  className?: string;
  disabled?: boolean;
  headerClassName?: string;
}

export default function Accordion({
  title,
  children,
  defaultOpen = false,
  className = "",
  disabled = false,
  headerClassName = "",
}: AccordionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const handleToggle = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
    }
  };

  return (
    <div
      className={combineClassName([
        disabled ? "opacity-50" : "",
        disabled ? "cursor-not-allowed" : "cursor-pointer",
        isOpen ? "bg-gray-100" : "",
        "rounded-lg border border-gray-200",
        className,
      ])}
    >
      <button
        type="button"
        onClick={handleToggle}
        disabled={disabled}
        className={combineClassName([
          "flex w-full min-w-0 items-center justify-between gap-2 text-left transition-colors duration-150 rounded-t-lg",
          !disabled && "hover:bg-gray-200",
          isOpen && "bg-gray-200",
          headerClassName,
        ])}
      >
        {title}
        {isOpen ? (
          <ChevronDownIcon className="h-4 w-4 text-gray-500" />
        ) : (
          <ChevronRightIcon className="h-4 w-4 text-gray-500" />
        )}
      </button>
      {isOpen && children}
    </div>
  );
}
